import React, {Component} from 'react'
import calculateRatio from '../../helpers/calculateRatio';

class TableBodyReport extends Component {
    render() {
        const {data, typeReport, periodType} = this.props
        let titleRow1 = '';
        let titleRow2 = '';
        let titleRow3 = '';
        switch (typeReport) {
            case 'product_results':
                titleRow1 = 'Tổng số lượng item được đóng thùng';
                titleRow2 = 'Tổng số lượng item đẩy xưởng';
                titleRow3 = 'Tỉ lệ sản xuất';
                break;
            case 'process_quality':
                titleRow1 = 'Tổng số lượng item lỗi';
                titleRow2 = 'Tổng số lượng item được đóng thùng';
                titleRow3 = 'Tỉ lệ lỗi';
                break;
            case 'customer_service':
                titleRow1 = 'Tổng số lượng item bị claim lỗi';
                titleRow2 = 'Tổng số lượng item được đóng thùng';
                titleRow3 = 'Tỉ lệ bị claim';
                break;
            default:
                titleRow1 = 'Tổng số lượng item được đóng thùng';
                titleRow2 = 'Tổng số lượng item đẩy xưởng';
                titleRow3 = 'Tỉ lệ sản xuất';
        }

        return (
            <tbody>
                <tr className={`TableRowItem}`}>
                    <td>{titleRow1}</td>

                    {data.map((item, idx) => (
                        <td key={idx}>{item.totalX}</td>
                    ))}
                </tr>

                <tr className={`TableRowItem}`}>
                    <td>{titleRow2}</td>

                    {data.map((item, idx) => (
                        <td key={idx}>{item.totalY}</td>
                    ))}
                </tr>
                
                <tr className={`TableRowItem}`}>
                    <td>{titleRow3}</td>

                    {data.map((item, idx) => {
                            if(typeReport === 'product_results' && periodType === '1D'){
                                return <td>--</td>
                            }else{
                                return <td key={idx}>{calculateRatio(item.totalX, item.totalY)}%</td>
                            }
                        }
                    )}
                </tr>
                
            </tbody>
        )
    }
}

export default TableBodyReport
